
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/choose-your-agent",
      function () {
        return require("private-next-pages/choose-your-agent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/choose-your-agent"])
      });
    }
  